import React from "react";
import { FormattedMessage } from "react-intl";
import Image from "../../general-components/image/image";
import LazyLoad from "react-lazyload";

const Sponsors = ({ content }) => {
  let sponsors = [""],
    label = "presented_by";

  const filteredAppearances = content.fieldAppearances.filter(Boolean);
  if (filteredAppearances?.length) {
    filteredAppearances.forEach((appearance, i) => {
      if (appearance.fieldMainPresenterOsRawField?.list) {
        sponsors = [
          ...sponsors,
          ...appearance.fieldMainPresenterOsRawField.list,
        ];
      }

      if (
        !!appearance.fieldSponsorLabel &&
        appearance.fieldSponsorLabel !== label
      ) {
        label = appearance.fieldSponsorLabel;
      }
    });

    filteredAppearances.forEach((appearance, i) => {
      if (appearance.fieldPresenterOsRawField?.list)
        sponsors = [...sponsors, ...appearance.fieldPresenterOsRawField.list];
    });
  }

  if (content.fieldCoopCompanyRawField?.list) {
    sponsors = [...sponsors, ...content.fieldCoopCompanyRawField?.list];
  }

  // Remove duplicates based on sponsor.targetId
  sponsors = sponsors.reduce((acc, current) => {
    const x = acc.find((item) => item.targetId === current.targetId);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);

  sponsors = sponsors.filter((e) => {
    return e;
  });

  if (sponsors && sponsors.length > 0 && sponsors !== [""]) {
    return (
      <div className="sponsor-wrapper">
        <div className="all-sponsors">
          <div className="row">
            <div className="label body-m col-12">
              <FormattedMessage id={label} />
            </div>
            {sponsors &&
              sponsors.length > 0 &&
              sponsors.map((sponsor, index) => (
                <>
                  {sponsor?.entity?.fieldImage && (
                    <div className="sponsor main col" key={index}>
                      <div className={`sponsor-image`}>
                        <a
                          href={sponsor.entity?.fieldWebsite?.uri?.path}
                          target="_blank"
                        >
                          {sponsor.entity?.fieldImage && (
                            <>
                              <span className="sr-only">
                                {sponsor.entity.title}
                              </span>
                              {sponsor.entity.fieldImage?.fieldMediaImage && (
                                <LazyLoad>
                                  <Image
                                    data={
                                      sponsor.entity.fieldImage.fieldMediaImage
                                    }
                                    // credit={sponsor.entity.fieldImage.fieldCredits}
                                    nodeTitle={sponsor.entity.title}
                                  />
                                </LazyLoad>
                              )}
                            </>
                          )}
                        </a>
                      </div>
                    </div>
                  )}
                </>
              ))}
          </div>
        </div>
      </div>
    );
  } else {
    return false;
  }
};

export default Sponsors;
